import processed from '../../api/moudles/processed.js' 
import order from '../../api/moudles/order.js' 
import newOrder from '../../api/moudles/newOrders.js' 
import print from '../../api/moudles/print.js' 
import {
	Message
} from 'element-ui'
import utils from '../../utils/utils.js'

import {
	SET_PROCESSED_ORDER_LIST,
	SET_INTN

} from '../mutation-types'




const state = () => ({
	processedList:[],//云仓的订单
	processedListCopy:[new Map()],
	cloudeList:[],//测品仓的出库订单 
	logisticsInfo:[{
				Id:'',
				Name:'全部',
				num:''
			}],
	count:0,
	cloudeListNum:0,
	amountList:[],
	tableList:[],
	falg:false,
	allLogistic:null,
	printedOrders:false,
	amountListCount:0
	

	
})

const getters = {}

const actions = {
		//获取已出库的订单信息-订单号查找
	getOrderByOrderId({state,dispatch}, payload) {
		processed
			.getOrderByOrderId(payload)
			.then(res => {
				if (res.code === 200) {
					console.log('订单号查找',res.data)
					state.amountList=res.data
				}
			})
	},
	//卖家获取所有已处理的订单
	getProcessedOrderBySeller({state,dispatch}, payload) {
		processed
			.getProcessedOrderBySeller(payload)
			.then(res => {
				if (res.code === 200) {
					console.log('卖家获取所有已处理的订单',res.data)
					state.tableList=res.data
					if(state.printedOrders){//打印签单或导出订单
						state.printedOrders=false
					}else{
						state.falg=true
						setTimeout(() => {
							state.falg=false
						})
					}
					
				}
			})
	},
	
	
	//仓库获取所有已处理的订单
	getProcessedOrderByStore({state,dispatch}, payload) {
		processed
			.getProcessedOrderByStore(payload)
			.then(res => {
				if (res.code === 200) {
					console.log('仓库获取所有已处理的订单',res.data)
					state.tableList=res.data
					state.falg=true 
					setTimeout(() => {
						state.falg=false
					})
				}
			})
	},
	
	//仓库获取所有物流方式
	getLogisticsBystore({state,dispatch}, payload) {
		processed
			.getLogisticsBystore(payload)
			.then(res => {
				if (res.code === 200) {
					console.log('仓库获取所有物流方式',res.data)
					let count=0
					res.data.forEach(p => {
						count += p.count
					})
					state.logisticsInfo=[{
								Id:'',
								Name:'全部',
								num:count
							}]
					
					res.data.forEach((p,index) => {
						if(p.logistics){
							state.logisticsInfo.push({
								Id:p.logistics,
								Name:p.logistics,
								num:p.count
							})
							
						}
					})
					
					console.log(state.logisticsInfo)
				}
			})
	},
	
	//卖家获取所有物流方式
	getLogisticsByseller({state,dispatch}, payload) {
		processed
			.getLogisticsByseller(payload)
			.then(res => {
				if (res.code === 200) {
					console.log('卖家获取所有物流方式',res.data)
					let count=0
					res.data.forEach(p => {
						count += p.count
					})
					state.logisticsInfo=[{
								Id:'',
								Name:'全部',
								num:count
							}]
					res.data.forEach((p,index) => {
							state.logisticsInfo.push({
								Id:p.logistics,
								Name:p.logistics,
								num:p.count
							})
					
					})
					
					console.log(state.logisticsInfo)
				}
			})
	},
	
	//卖家获取一段时间内打包的订单数量
	getProcessedOrders({state,dispatch}, payload) {
		processed
			.getProcessedOrders(payload)
			.then(res => {
				if (res.code === 200) {
					console.log('卖家获取一段时间内打包的订单数量',res.data)
					state.amountList=res.data.orders
					state.amountListCount=res.data.count
				}
			})
	},
	
	//仓库获取一段时间内打包的订单数量
	getProcessedOrdersByStore({state,dispatch}, payload) {
		processed
			.getProcessedOrdersByStore(payload)
			.then(res => {
				if (res.code === 200) {
					console.log('仓库获取一段时间内打包的订单数量',res.data)
					state.amountList=res.data
				}
			})
	},

	setPackagedCopy({state},payload){
		const p =new Promise((resolve) => {
			 newOrder
			.setPackaged(payload)
			.then(res => {
				if(res.code === 200) {
					state.processedList.unshift(res.data)
					Message({
						message: '订单成功出库！',
						type: 'success'
					})
				}else{
					resolve(res)
					state.falg=true
				}
			})
		})

		return p
	},
	
	setPackaged({state},payload){
		print
		.setPackaged(payload)
		.then(res => {
			if(res.code === 200) {
				state.processedList.unshift(res.data)
				Message({
					message: '订单成功出库！',
					type: 'success'
				})
			}else{
				Message({
					message: res.msg,
					type: 'error'
				})
				state.falg=true
			}
		})
	},
	
	
	//获取GoodsType
	getGoodsType({state},payload) {
		order
		.getGoodsType(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('goodstype',res.data)
				state.processedList.forEach(p => {
					if(p.ordersn === payload.ordersn){
						p.goodsType=res.data
					}
				})
			}
		})
	},	
	//获取印尼仓库帐号已处理已出库出库的订单
	getPackagedOrderByStore({state,dispatch}, payload) {
		processed
			.getPackagedOrderByStore(payload)
			.then(res => {
				if (res.code === 200) {
					console.log('印尼仓库用户已处理页面的订单',res.data)
					state.processedList=res.data.orders
					state.count=res.data.count
					// res.data.orders.sort((a,b) => {
					// 	return a.packagedTime<b.packagedTime ? 1 : -1
					// })
					// res.data.orders.forEach(p => {
					// 	state.processedList.push(p)
					// })
					
				}
			})
		},
	//获取印尼卖家帐号已处理已出库出库的订单
	getIDacountProcessedList({state,dispatch}, payload) {
		processed
			.getIDacountProcessedList(payload)
			.then(res => {
				if (res.code === 200) {
					console.log('印尼帐号下的已处理订单',res.data)
					state.processedList=res.data.orders
					state.count=res.data.count
				
				}
			})
		},
	// //先获取测品仓库填写了长宽高信息过来的订单信息
	// getProcessedOrderInfo({state,dispatch}, payload) {
	// 	processed
	// 		.getProcessedOrderInfo(payload)
	// 		.then(res => {
	// 			if (res.code === 200) {
	// 				console.log('先拿收货信息',res.data)
	// 				state.cloudeList=[]
	// 				state.logisticsInfo=res.data
	// 				state.count=res.data.length
	// 				let arr=res.data.map(p => {
	// 					return p.ordersn
						
	// 				})
	// 				console.log('先拿收货信息',arr)
					
	// 				dispatch('getProcessedOrderSn',arr)
	// 			}
	// 		})
	// 	},


	// //用订单号再获取原订单的所有信息
	// getProcessedOrderSn({state,commit}, payload) {
	// 		processed
	// 			.getProcessedOrderSn(payload)
	// 			.then(res => {
	// 				if (res.code === 200) {
	// 					state.logisticsInfo.forEach(p => {
	// 						if(p.ordersn === res.data.ordersn){
	// 							res.data.receiveInfo=p
	// 						}
	// 					})
	// 					state.cloudeList.push(res.data)
	// 					console.log('测品仓出库的订单',state.cloudeList)
	// 				}
	// 			})
	// 	}
	
}
const mutations = {
	[SET_PROCESSED_ORDER_LIST]:(state,orderList) => {
		state.printedOrders=true
	},
	[SET_INTN]:(state) => {
		state.amountList=[]
		state.amountListCount=0
	}


}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}